import { axiosConfig } from "../shared/api-client";
import { JIVANDHARA_BASE } from "../admin/list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/user-details`;

export interface UserDetails {
  id?: number;
  address_line_1?: string;
  address_line_2?: string;
  landmark?: string;
  city?: string;
  state?: string;
  pincode?: string;
  alternate_phone_number?: string;
  [key: string]: any;
}

class UserDetailsService {
  get = async (): Promise<UserDetails | undefined> => {
    try {
      const response = await axiosConfig.get<any>(`${BASE}/`, {
        showNotification: false,
      } as any);
      const data = response.data;
      if (data && typeof data === "object") {
        if (Array.isArray(data.results) && data.results.length > 0) {
          return data.results[0];
        }
        if (Array.isArray(data.data) && data.data.length > 0) {
          return data.data[0];
        }
        return data.data ?? data;
      }
      return undefined;
    } catch (err) {
      console.error("Failed to fetch user details:", err);
      return undefined;
    }
  };

  save = async (payload: UserDetails): Promise<UserDetails> => {
    if (payload.id) {
      const response = await axiosConfig.patch<any>(
        `${BASE}/${payload.id}/`,
        payload
      );
      return response.data?.data ?? response.data;
    } else {
      const response = await axiosConfig.post<any>(`${BASE}/`, payload);
      return response.data?.data ?? response.data;
    }
  };
}

export const userDetailsService = new UserDetailsService();
